import React, { useState, useEffect, useRef } from 'react';
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck, fileFormatter, } from 'utils/columns';
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import DeleteIcon from 'assets/icon/icon-icon-options-delete.svg';
import DeleteHoverIcon from 'assets/icon/icon-icon-options-delete-hover.svg';
import { Formik, Field } from 'formik';
import Confirm from 'components/Confirm';
import { toast } from 'react-toastify';
let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];
const PurchaseOrderComments = (props) => {

    const API = useAxios();
    const { tenantID, coveredEntityID, onCommentEdit, refetch,commentRowData } = props;
    const [data, setData] = useState([tableDataBackup]);
    const [isDeleteConfirm, setDeleteConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [commentId, setCommentId] = useState(-1);
    const formikRef = useRef();
    const fetchPatientComments = async () => {
        try {
            const { data } = await API.get(
                `/${tenantID}/Comments/ProgramComments/${coveredEntityID}/${"Audit"}/${commentRowData ==undefined?0:commentRowData.poid}`,
                {
                    hideLoader: true,
                }
            );
            setData(data);
        } catch (error) { }
    };

    useEffect(() => {
        fetchPatientComments();
    }, [refetch]);

    const download = async (file) => {
        const { fileRepositoryID } = file;
        try {
            const { access_token } =
                JSON.parse(localStorage.getItem('pharmaforce')) || {};
            const res = await API.get(
                `/${tenantID}/Comments/Download/${parseInt(
                    coveredEntityID
                )}/${fileRepositoryID}?access_token=${access_token}`,
                {
                    responseType: 'blob',
                }
            );
            if (res.request.responseType === 'blob') {
                window.open(res.request.responseURL);
            }
        } catch (error) { }
    };

    const cellRenderEdit = (row) => {
        return (
            <div className="d-flex align-items-center">
                {/* <Button
                    className="text-primary p-0 text-decoration-none"
                    color="link"
                    onClick={() => onEdit(row)}
                >
                    <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
                </Button> */}
                <Button
                    className="text-primary p-0 text-decoration-none"
                    color="link"
                    onClick={() => handleDeleteConfirmation(row)}
                >
                    <HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt='' />
                </Button>
            </div>
        );
    }
    const onEdit = (row) => {
        onCommentEdit(row);
    }

    const columns = [
        {
            dataField: 'edit',
            text: 'Options',
            width: 180,
            cellRenderer: (row) => cellRenderEdit(row),
            show: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'comments',
            text: 'Comments',
            width: 180,
            show: true,
        },
        {
            dataField: 'createdDate',
            text: 'Created Date',
            width: 60,
            cellRenderer: (row) => dateFormate(row.modifiedDate),
            show: true,
        },
        {
            dataField: 'createdBy',
            text: 'Modified By',
            width: 60,
            cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
            show: true,
        },
        {
            dataField: 'files',
            text: 'File',
            width: 100,
            show: true,
            cellRenderer: (row) => fileFormatter(row, download),
        },
    ];

    const handleDeleteConfirmation = async (row) => {
        setDeleteConfirm(!isDeleteConfirm);
        if (row) setCommentId(row.commentID);
    }
    const deleteRow = async () => {
        handleDeleteConfirmation();

        let result = await API.post(`/${tenantID}/Comments/inactivecomment/${coveredEntityID}/${commentId}`, null, {
            hideLoader: true,
        });
        if (result) {
            toast.success("Item removed successfully");
            fetchPatientComments();
        }
    }


    return (
        <>
            <Formik
                innerRef={formikRef}
                enableReinitialize={true}
            >
                <ReactStrapTable
                    id='commnets'
                    height={30 * data.length}
                    columns={columns}
                    data={data}
                // loading={loading}
                />
            </Formik>
            <Confirm
                isOpen={isDeleteConfirm}
                loading={loading}
                message='Are you sure you want to delete this comment?'
                onToggle={handleDeleteConfirmation}
                onCancel={handleDeleteConfirmation}
                onContinue={deleteRow}
            />


        </>
    );
};

export default PurchaseOrderComments;
